var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statistics-card"},[_c('span',{staticClass:"statistics-card__title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"statistics-card__value"},[_vm._v(_vm._s(_vm.commna))])])}
var staticRenderFns = []

export { render, staticRenderFns }